import clsx from "clsx"
import { useHistory } from "react-router-dom"

import { Table } from "@/components/Table"
import { WeatherIcon } from "@/components/WeatherIcon"
import { getStatsColor, getTrafficValueColor } from "@/utils"

import { TeamWithStats } from "../EventsStatistics/TeamStats"
import { changeTeam, handleDriversCountClick, handleOrdersCountClick, handleUnsettledPaymentsClick } from "../utils"
import { EventsTableHeader } from "./EventsList"
import cls from "./EventsList.module.scss"

type EventsListItemProps = {
  teamWithStats: TeamWithStats
  hiddenColumns: EventsTableHeader[]
}

export const EventsListItem = ({ teamWithStats, hiddenColumns }: EventsListItemProps) => {
  const team = teamWithStats.team
  const stats = teamWithStats.stats

  const history = useHistory()

  return (
    <Table.Tr loading={!stats} className={clsx(cls.teamRow, stats && cls[`teamRowBg-${getStatsColor(stats)}`])}>
      <Table.Td className={cls.teamNameTd}>
        <div
          className={clsx(cls.teamName, cls.statusBar, stats && cls[`status--${getStatsColor(stats)}`])}
          onClick={() => changeTeam(team, history)}
        >
          {team.name}
        </div>
      </Table.Td>

      {!hiddenColumns.includes("active_drivers_count") && (
        <Table.Td
          className="cursor-pointer"
          onMouseDown={(event) => handleDriversCountClick("inactive", team, event, history)}
        >
          <span className={clsx(stats && `text-${getStatsColor(stats, "active_drivers_count")}`)}>
            {stats?.active_drivers_count}
          </span>
          {stats?.total_drivers_count !== 0 && stats?.total_drivers_count && (
            <span className="text-muted">{` / ${stats?.total_drivers_count}`}</span>
          )}
        </Table.Td>
      )}

      {!hiddenColumns.includes("blocked_drivers_count") && (
        <Table.Td
          className="cursor-pointer"
          onMouseDown={(event) => handleDriversCountClick("blocked", team, event, history)}
        >
          <span className={clsx(stats && `text-${getStatsColor(stats, "blocked_drivers_count")}`)}>
            {stats?.blocked_drivers_count}
          </span>

          {stats?.total_drivers_count !== 0 && stats?.total_drivers_count && (
            <span className="text-muted">{` / ${stats?.total_drivers_count}`}</span>
          )}
        </Table.Td>
      )}

      {!hiddenColumns.includes("today_orders_count") && <Table.Td>{stats?.today_orders_count}</Table.Td>}

      {!hiddenColumns.includes("load_value") && (
        <Table.Td>
          <div className={clsx(stats && `text-${getStatsColor(stats, "load_value")}`)}>{stats?.load_value}</div>
        </Table.Td>
      )}

      {!hiddenColumns.includes("late_drivers_count") && (
        <Table.Td
          className="cursor-pointer"
          onMouseDown={(event) => handleDriversCountClick("late", team, event, history)}
        >
          <span className={clsx(stats && `text-${getStatsColor(stats, "late_drivers_count")}`)}>
            {stats?.late_drivers_count}
          </span>

          {stats?.total_drivers_count !== 0 && stats?.total_drivers_count && (
            <span className="text-muted">{` / ${stats?.total_drivers_count}`}</span>
          )}
        </Table.Td>
      )}

      {!hiddenColumns.includes("today_delivery_orders_count") && (
        <Table.Td>{stats?.today_delivery_orders_count}</Table.Td>
      )}

      {!hiddenColumns.includes("unsettled_payments_count") && (
        <Table.Td
          className="cursor-pointer"
          onMouseDown={(event) => handleUnsettledPaymentsClick(team, event, history)}
        >
          {stats?.unsettled_payments_count}
        </Table.Td>
      )}

      {!hiddenColumns.includes("dynamic_buffer_real_value") && (
        <Table.Td className={clsx(stats && `text-${getStatsColor(stats, "dynamic_buffer_real_value")}`)}>
          {stats?.dynamic_buffer_real_value
            ? `${stats?.dynamic_buffer_real_value} min.`
            : stats?.dynamic_buffer_real_value}
        </Table.Td>
      )}

      {!hiddenColumns.includes("traffic_value") && (
        <Table.Td className={`text-${getTrafficValueColor(stats?.traffic_value)}`}>
          {stats?.traffic_value ? `${stats.traffic_value}%` : "-"}
        </Table.Td>
      )}

      {!hiddenColumns.includes("omitted_orders_count") && (
        <Table.Td
          className={clsx(stats && `text-${getStatsColor(stats, "omitted_orders_count")}`, "cursor-pointer")}
          onMouseDown={(event) => handleOrdersCountClick("omitted", team, event, history)}
        >
          {stats?.omitted_orders_count}
        </Table.Td>
      )}

      {!hiddenColumns.includes("weather") && (
        <Table.Td>{stats ? <WeatherIcon weather={stats.weather} fallback="-" /> : "-"}</Table.Td>
      )}
    </Table.Tr>
  )
}
